export * from "./HeadingName";